// extracted by mini-css-extract-plugin
export var addressAddress = "detailsAddress-module--address-address--66418";
export var addressBody = "detailsAddress-module--address-body--3e9f6";
export var addressContact = "detailsAddress-module--address-contact--0826e";
export var addressContent = "detailsAddress-module--address-content--cd0cc";
export var addressContentContainer = "detailsAddress-module--address-content-container--84cc8";
export var addressFooter = "detailsAddress-module--address-footer--0607c";
export var addressFooterBack = "detailsAddress-module--address-footer-back--72dfd";
export var addressImage = "detailsAddress-module--address-image--0edf3";
export var addressMail = "detailsAddress-module--address-mail--f65a2";
export var addressPlace = "detailsAddress-module--address-place--4e8d2";
export var addressPlaceIcon = "detailsAddress-module--address-place-icon--a609d";
export var addressPlaceTitle = "detailsAddress-module--address-place-title--4543e";
export var addressTel = "detailsAddress-module--address-tel--f32d4";
export var addressTitle = "detailsAddress-module--address-title--fb9d3";
export var editButton = "detailsAddress-module--edit-button--34cc2";
export var pageAddress = "detailsAddress-module--page-address--e0ed9";
export var pageAddressAdditionalInfos = "detailsAddress-module--page-address-additional-infos--9eb4e";